import { useMemo } from 'react';

import { makeSecuredMediaURLRelative } from '@lumapps/medias/utils';
import { getMoment } from '@lumapps/utils/time/getMoment';
import { getCurrentTimezoneFormated } from '@lumapps/utils/timezones/getCurrentTimezone';

import { Event, LayoutEvent } from '../api/types';
import { eventView } from '../routes';

export const useEventPreview = (event: Event | LayoutEvent, isLegacy?: boolean) => {
    const moment = getMoment();
    const eventRoute = useMemo(() => eventView(event.id), [event.id]);

    const imageInfos = () => {
        if (isLegacy) {
            const { url, focalPoint } = (event as Event).structuredContent.richText?.value?.featuredImage || {};
            if (!url) {
                return undefined;
            }

            return {
                href: eventRoute,
                url: makeSecuredMediaURLRelative(url) as string,
                focusPoint: focalPoint,
            };
        }

        const { image, focalPoint } = event as LayoutEvent;
        if (!image) {
            return undefined;
        }
        return {
            href: eventRoute,
            url: image,
            focusPoint: focalPoint,
        };
    };

    const title = !isLegacy ? (event as LayoutEvent).title : (event as Event).structuredContent.title?.value;

    const formatedTimezone = getCurrentTimezoneFormated();

    const formatedStartsAt = moment.utc(event.startsAt).local().format('LLLL');
    const formatedEndsAt = moment.utc(event.endsAt).local().format('LLLL');

    const intro = !isLegacy ? (event as LayoutEvent).description : (event as Event).structuredContent.intro?.value;

    return {
        id: event.id,
        eventRoute,
        image: imageInfos(),
        title,
        startDate: {
            startsAt: event.startsAt,
            formatedStartsAt,
            formatedTimezone,
        },
        endDate: formatedEndsAt,
        duration: event.duration,
        location: event.location,
        externalUrl: event.externalUrl,
        externalUrlLabel: event.externalUrlLabel,
        intro,
        currentRegistrationStatus: event?.registrationStatus,
        organizers: event?.organizers,
        remainingSpots: event?.remainingSpots,
        hasLimitedCapacity: event?.hasLimitedCapacity,
        hasRegistrationEnabled: event?.hasRegistrationEnabled ?? true,
        registrationType: event?.registrationType,
    };
};
